import {Component, inject} from '@angular/core';
import {CharityManagementComponent} from "../charity-management.component";
import {ColComponent, ContainerComponent, ListGroupDirective, ListGroupItemDirective, RowComponent} from "@coreui/angular";
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {CharityManagementScreenState} from "../../../enum/CharityManagementScreenState";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {CharityService} from "../../../services/charity.service";
import {
  MovePlayersPledgesBetweenCharitiesComponent
} from "../../../components/charity/move-players-pledges-between-charities/move-players-pledges-between-charities.component";

@Component({
  selector: 'app-cross-game-charity-management',
  standalone: true,
  imports: [
    CharityManagementComponent,
    ContainerComponent,
    ChooseYourGameComponent,
    ColComponent,
    HasPermissionDirective,
    ListGroupDirective,
    ListGroupItemDirective,
    RowComponent,
    MatButton,
    MatIcon,
    MovePlayersPledgesBetweenCharitiesComponent
  ],
  templateUrl: './cross-game-charity-management.component.html',
  styleUrl: './cross-game-charity-management.component.css'
})
export class CrossGameCharityManagementComponent {

  private charityService: CharityService = inject(CharityService);

  protected game: IGameQueryResult | null = null;
  protected currentScreenState: CharityManagementScreenState = CharityManagementScreenState.SortAndView;
  protected readonly PermissionTypes = PermissionTypes;
  protected readonly charityManagementScreenState = CharityManagementScreenState;

  onGameChosen(chosenGameP: IGameQueryResult) {
    this.game = chosenGameP;
  }

  addNewCharities() {
    this.charityService.openAddCharityDialog(this.game?.Id!);
  }
}
